<template>
  <div class="placeOrder warp">
    <div class="poAddressBox">
      <div class="poTitle">请选择收货地址</div>
      <!-- <div class="noAddress" v-if="addressData.length === 0" @click="newAddressFn">
            <div class="noAddressBox">
              <span class="iconfont">&#xe6d4;</span>
              <span>新增收货地址</span>
            </div>
      </div>-->
      <div class="poAddressList">
        <div class="poAddListTit" @click="newAddressFn">
          <a-icon type="environment" />
          <span>新增收货地址</span>
        </div>
        <div class="poAddListBox" v-if="addressData.length !== 0">
          <div>收货地址</div>
          <div>
            <div class="showMoreBox" :class="{ showMoreAdd: showMoreAddress }">
              <div class="addressItem" :class="{ addressActive: curAdd === index }" @click="selectAddress(item, index)"
                v-for="(item, index) of addressData" :key="item.receiveId">
                <span class="userName">{{ item.receiveName }}</span>
                <span class="addressInfo">{{ item.receiveAdress }} {{ item.address }}</span>
                <span class="phone">{{ item.receivePhone }}</span>
                <span class="defaultAddress" :class="`${item.ifDefault ? 'hasHeader' : ''}`">{{ item.ifDefault ? "默认地址"
                : "" }}</span>
                <span class="el-icon-edit" @click.stop="editAddress(item, index)"></span>
                <span @click.stop="showDelete(item)">
                  <i class="iconfont">&#xe62c;</i>
                </span>
                <!-- <span class="el-icon-edit" @click.stop="editAddress(item, index)"></span> -->
                <i v-if="curAdd === index" class="iconfont">&#xe612;</i>
              </div>
            </div>
            <div v-if="addressData.length > 3" class="openMore iconfont" @click="openMoreAdd"
              v-html="showMoreAddress ? '&#xe660;' : '&#xe695;'"></div>
          </div>
        </div>
      </div>
      <div class="poTitle">请确认订单信息</div>
      <div class="orderList">
        <div class="orderInfoTit">
          <span>商品名称</span>
          <span>商品属性</span>
          <span>单价</span>
          <span>数量</span>
          <span>优惠方式</span>
          <span>小计</span>
        </div>
      </div>
      <shop-order ref="shopOrder" :type="state" :shopsData="shopsData"></shop-order>
    </div>
    <div class="remarksBox">
      <div class="remarksInfo">
        <el-input type="textarea" :rows="2" resize="none" maxlength="200" placeholder="如有其他要求，请备注。"
          v-model="remarksInfo"></el-input>
      </div>
    </div>
    <div class="couponBox">
      <div class="couponTitle" v-if="settlementData.coupons.length !== 0">
        <span>
          使用优惠券
          <i class="iconfont" v-html="'&#xe695;'"></i>
        </span>
      </div>
      <div class="discountList clearfix">
        <!-- <div @click="preferentialUse(item, index)" class="couponItem" :class="{active: currentCoupon === index}" v-for="(item, index) of settlementData.coupons" :key="item.couponId"> -->
        <div @click="preferentialUse(item, index)" class="couponItem" :class="{ active: curPrefCouponInx === index }"
          v-for="(item, index) of settlementData.coupons" :key="item.couponId">
          <div class="couponItemTop">
            <img src="../../assets/images/indexLogo.png" alt />
            <span>
              <i>￥</i>
              {{ item.reduceMoney }}
            </span>
            <span style="height: 15px">使用条件：{{ item.content }}</span>
            <span>有效期至：{{ item.endTime }}</span>
            <div class="couponType">平台卷</div>
          </div>
          <div class="couponItemBot">
            立即使用
            <span class="iconfont currentSelect" v-if="curPrefCouponInx === index">&#xe612;</span>
          </div>
        </div>
        <div v-for="(item, index) of shopsData" :key="item.shopId">
          <!-- <div @click="selectShopCoupon(shop, shopIndex)" class="couponItem" :class="{active: currentShopCoupon === shopIndex}" v-for="(shop, shopIndex) of item.shopCoupons" :key="shop.id"> -->
          <div @click="selectShopCoupon(item, index, shop)" class="couponItem"
            :class="{ active: shopCoupons[index].id === shop.id }" v-for="shop of item.shopCoupons" :key="shop.id">
            <div class="couponItemTop">
              <img src="../../assets/images/indexLogo.png" alt />
              <!--                <span><i>￥</i>{{item.reduceMoney}}</span>-->
              <span>优惠：{{ shop.content }}</span>
              <span style="height: 15px"></span>
              <span>有效期至：{{ shop.endTime }}</span>
              <div class="couponType">店铺券</div>
            </div>
            <div class="couponItemBot">
              立即使用
              <!-- <span class="iconfont currentSelect" v-if="currentShopCoupon === shopIndex">&#xe612;</span> -->
              <span class="iconfont currentSelect" v-if="shopCoupons[index].id === shop.id">&#xe612;</span>
            </div>
          </div>
        </div>
      </div>
      <div class="couponList">
        <div class="payTit">选择支付方式</div>
        <div style="display:flex;justify-content:flex-start;align-item:center;flex-wrap: wrap;">
          <div class="payList">
            <!--            <span :class="{payActive: payType === 'alipay'}" @click="selectPay(type = 'alipay')">-->
            <!--              <i class="iconfont">&#xe627;</i>-->
            <!--              <b class="iconfont">&#xe612;</b>-->
            <!--              支付宝支付-->
            <!--            </span>-->
            <!-- <span :class="{payActive: payType === 'weChat'}" @click="selectPay(type = 'weChat')">
                  <i class="iconfont">&#xe686;</i>
                  <b class="iconfont">&#xe612;</b>
                  微信支付
            </span>-->
            <!-- <div @click="selectPay((type = '1'))" :class="{ payActive: payType === '1' }"
              v-if="enablePaymentMode.indexOf(1) != -1">
              <img src="../../assets/images/online_pay.png" alt />
              <div>
                <p>在线支付</p>
                <p>支持微信、支付宝、云闪付等具有扫码支付功能的APP</p>
              </div>
              <span class="el-icon-check" v-if="payType === '1'"></span>
            </div> -->
            <div @click="selectPay((type = '3'))" :class="{ payActive: payType === '3' }"
              v-if="enablePaymentMode.indexOf(3) != -1">
              <img src="../../assets/images/offline_pay.png" alt />
              <div>
                <p>转账汇款</p>
                <p>收款账户:保山数字产业发展有限责任公司</p>
              </div>
              <span class="el-icon-check" v-if="payType === '3'"></span>
            </div>
            <div @click="selectPay((type = '4'))" :class="{ payActive: payType === '4' }">
              <img src="../../assets/images/online_credit_pay.png" alt v-if="chackData.flag == 3" />
              <img src="../../assets/images/payment@2x.png" alt v-if="
                chackData.flag == 4 ||
                chackData.flag == 5 ||
                chackData.flag == 6 ||
                chackData.flag == 1 ||
                chackData.flag == 2
              " />
              <div>
                <p>
                  账期支付
                  <span class="hint" v-if="chackData.flag == 1">(未开通)</span>
                  <span class="hint" v-else-if="chackData.flag == 2">
                    (等待商家审核)
                  </span>
                  <span class="hint" v-else-if="chackData.flag == 3 && !balanceAmount">
                    (已开通)
                  </span>
                  <span class="hint gray" v-else-if="chackData.flag == 4">
                    (已冻结)
                  </span>
                  <span class="hint gray" v-else-if="chackData.flag == 5">
                    (已终止)
                  </span>
                  <span class="hint gray" v-else-if="chackData.flag == 6">
                    (存在未开通账期的商品)
                  </span>
                  <span class="hint gray" v-else-if="balanceAmount">
                    (余额不足)
                  </span>
                </p>
                <p style="color: #999999" class="p1" v-if="
                  chackData.flag == 4 ||
                  chackData.flag == 5 ||
                  chackData.flag == 2
                ">
                  联系商家协商：{{ chargePersonPhone }}
                </p>

                <p v-if="chackData.flag == 3 || chackData.flag == 6">
                  还有
                  <span>{{ chackData.balanceAmount }}</span>
                  额度可以使用
                  <span style="color: #ff4747; margin-left: 10px" v-if="balanceAmount">
                    联系商家：{{ chargePersonPhone }}
                  </span>
                </p>
                <p style="color: #999999;margin-top:10px;" class="p1" v-if="chackData.flag == 6">
                  联系商家开通：{{ chargePersonPhone }}
                </p>
                <p class="open" v-if="chackData.flag == 1">
                  <span @click="paymentDays = true">立即开通</span>
                </p>
              </div>
              <span class="el-icon-check" v-if="payType === '4'"></span>
            </div>
          </div>
          <div class="payList" v-if="enablePaymentMode.indexOf(6) != -1">
            <div @click="selectPay((type = '6'))" :class="{ payActive: payType === '6' }">
              <img src="../../assets/images/jufutong.png" alt />
              <div>
                <p>聚富通支付</p>
                <p>工商银行储蓄卡</p>
              </div>
              <span class="el-icon-check" v-if="payType === '6'"></span>
            </div>
          </div>
          <div class="payList" v-if="enablePaymentMode.indexOf(7) != -1">
            <div @click="selectPay((type = '7'))" :class="{ payActive: payType === '7' }">
              <img src="../../assets/images/jufutong.png" alt />
              <div>
                <p>e企付</p>
                <p>工商银行储蓄卡</p>
              </div>
              <span class="el-icon-check" v-if="payType === '7'"></span>
            </div>
          </div>
        </div>

        <el-dialog title="开通账期" :visible.sync="paymentDays" :center="false" width="542px">
          <div class="confimPaymentDaysContent">
            <p class="p1">
              您好，您正在申请开通当前店铺的“账期支付”功能，请您认真阅读以下信息：
            </p>
            <p class="p1">
              账期支付是先消费后付款的支付服务，其法律关系仅存在于您与商家之间。商家将根据您当前帐号的信誉和交易合作进行评估，自行决定是否为您开通“账期支付”功能以及设置具体使用细则（包括但不限于账期额度、支付周期、授权商品、使用条件等）。
            </p>
            <p class="p1">
              账期支付功能开通后，您可使用商家授信的账期额度采购商家授权的商品，您需在支付周期内结清应还款项。
            </p>
            <p class="p1">
              关于“账期支付”具体使用细则您可联系当前店铺客服进行协商。线上客服入口正在开发中，您可通过店铺客服电话或微信联系商家。
            </p>
            <p>
              {{ chargePersonName }}店铺客服电话：
              <span>{{ chargePersonPhone }}</span>
            </p>
          </div>
          <span slot="footer" class="dialog-footer">
            <div class="confimPaymentDays1" @click="paymentDays = false">
              取消
            </div>
            <div class="confimPaymentDays2" @click="applyForMoney">
              点击确认提交申请
            </div>
          </span>
        </el-dialog>
        <el-dialog :visible.sync="confirmApplyForMoney" width="26%" :show-close="true">
          <div class="confirmApplyForMoney">
            <div>
              <img src="../../assets/images/success@2x.png" alt />
            </div>
            <div>申请提交,等待商家授信!</div>
          </div>
        </el-dialog>
      </div>
    </div>
    <a-spin :spinning="spinning">
      <div class="placeOrderBtn">
        <!-- <span>商品优惠：-￥{{(prefAmount + shopDiscountAmount).toFixed(2)}}</span> -->
        <span>运费：+¥{{ distributionPrice }}</span>
        <span>商品优惠：-￥{{ prefDis + shopCouponDis }}</span>
        <span>
          需付款：
          <b>￥{{ orderDisTotal }}</b>
        </span>
        <el-button @click="clickPayOrder" type="primary" v-throttle>提交订单</el-button>
      </div>
    </a-spin>
    <el-dialog title="请在1小时内完成付款，否则订单会被系统取消" :visible.sync="paymentDialog" width="30%">
      <div class="payment">
        <div class="paymentBox">
          <div class="successBox">
            <span>支付成功请点击</span>
            <el-button type="primary" plain>已完成付款</el-button>
          </div>
          <div class="errorBox">
            <span>遇到问题请点击</span>
            <el-button type="primary" v-throttle>重新付款</el-button>
          </div>
        </div>
        <div class="paymentInfo">
          <p>注：重新付款前，请关闭之前的付款页面</p>
          <p>
            如有疑问或需要帮助，请进入
            <b>帮助中心</b>或联系
            <b>在线客服</b>
          </p>
        </div>
      </div>
    </el-dialog>
    <el-dialog class="weChat" :visible.sync="weChatDialog" :before-close="handleClose" width="25%">
      <div class="weChatBox" style="">
        <div style="font-size: 18px; color: #000000; padding: 0 20px">
          请使用具有扫码支付功能的APP完成支付（支持微信、支付宝、云闪付等APP）
        </div>
        <div style="
            font-size: 32px;
            color: #000000;
            width: 100%;
            text-align: center;
          ">
          ￥{{ payInfo.money }}
        </div>
        <div class="qCode">
          <img :src="`data:image/jpeg;base64,${payInfo.c2bQrCodeBase64}`" width="100%" height="100%" alt />
          <!-- <img src="../../assets/images/weiXintit.png" alt=""> -->
        </div>
        <!-- <div class="weChatInfo">
            <img src="../../assets/images/imgPay.png" alt="">
        </div>-->
      </div>
    </el-dialog>
    <el-dialog :title="`${curDialogAddress ? '编辑' : '新建'}收货地址`" :visible.sync="newAddressDialog" width="630px">
      <add-address @hideAddDialog="hideAddDialog" @cancelAdd="closeAdd"></add-address>
    </el-dialog>
    <el-dialog title="是否删除此项" :visible.sync="showDeleteAdd" width="30%">
      <div class="deleteAddInfo">
        <p>收货人： {{ delCurrentAdd.receiveName }}</p>
        <p>手机号码： {{ delCurrentAdd.receivePhone }}</p>
        <p>
          收货地址： {{ delCurrentAdd.receiveAdress }}
          {{ delCurrentAdd.address }}
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDeleteAdd = false">取 消</el-button>
        <el-button type="primary" @click="deleteAdd" v-throttle>确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="错误！" :visible.sync="errorDialog" width="30%">
      <div class="errorDialog">
        <div class="errorTit">
          <span class="iconfont">&#xe620;</span>
          <p>您的订单支付失败</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" v-throttle>查看订单</el-button>
          <el-button type="primary" @click="dialogVisible = false" v-throttle>重新支付</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import addAddress from "../../components/orderInfo/addAddress";
import shopOrder from "../../components/orderInfo/shopOrder";
import couponList from "../../components/orderInfo/coupon";
import api from "@/api";
import { listSearchMixin } from "@/config/mixin";
import { mapGetters, mapMutations } from "vuex";
import { TextToCode } from "element-china-area-data";
import DiscountList from "../../components/canvasShow/basics/discountList.vue";
export default {
  name: "placeOrder",
  mixins: [listSearchMixin],
  components: {
    addAddress,
    shopOrder,
    couponList,
    DiscountList
  },
  data() {
    return {
      confirmApplyForMoney: false, // 确定后的弹窗
      paymentDays: false,
      spinning: false,
      addressData: [],
      showMoreAddress: false,
      newAddressDialog: false,
      paymentDialog: false,
      weChatDialog: false,
      payType: "",
      errorDialog: false,
      curAdd: 0,
      settlementData: {
        coupons: [],
      },
      shopsData: [],
      showDiscount: false,
      currentCoupon: null,
      currentShopCoupon: null,
      prefAmount: 0,
      shopDiscountAmount: 0,
      currentDiscount: 0,
      discountTotal: 0, // 优惠总额
      orderTotal: 0,
      couponCurrent: {},
      shopCouponCurrent: {},
      submitData: {
        receiveId: "",
        couponId: "",
        price: "",
        remark: "",
        shops: [],
      },
      currentAddressId: "",
      remarksInfo: "",
      payInfo: {},
      chatTimer: "",
      activityType: null,
      workData: {},
      shopData: [],
      type: null,
      ifWork: null,
      discount: 0,
      shopCouponDis: 0, // 使用店铺券后的优惠额度
      prefDis: 0, // 使用平台券后的优惠额度
      curPrefCoupon: null, // 当前平台券
      curShopCoupon: null, // 当前店铺券
      curPrefCouponInx: null, // 当前平台券的索引
      curShopCouponId: null, // 当前店铺券的id
      orderDisTotal: 0, // 减去优惠后的付款价格
      state: 0,
      shopCoupons: [],
      distributionPrice: 0, // 总运费
      curDialogAddress: null,
      showDeleteAdd: false,
      delCurrentAdd: {},
      chargePersonPhone: "", // 商家电话(负责人电话)
      chargePersonName: "",
      chackData: {},
      enablePaymentMode: [],
      balanceAmount: false,
      shopsTotal: "",
      productIdList: [],
      submitFlag: false
    };
  },
  created() {
    if (this.$route.query.works) {
      this.workData = JSON.parse(this.$route.query.works);
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.$route.query.ifWork !== undefined) {
      this.ifWork = this.$route.query.ifWork;
    }
    this.activityType = this.$route.query.activityType;
    if (this.$route.query.shops) {
      this.shopData = JSON.parse(this.$route.query.shops);
    }
    if (this.shopData.shopDiscountId) {
      this.state = 3;
    }
    if (this.shopData.shopSeckillId) {
      this.state = 2;
    }
    if (this.workData.shopGroupWorkId) {
      this.state = 1;
    }
  },
  mounted() {
    // 获取地址列表
    this.getAddressList();

    if (this.$route.query.type) {
      this.getSetProList();
    } else {
      this.getWorkSettlement();
    }
  },
  computed: {
    ...mapGetters([
      "newAddress", // 新增修改收货地址
    ]),
  },
  methods: {
    ...mapMutations({
      seNewAddress: "SET_NEWADDRESS", // 新增修改收货地址
      setAreacode: "SET_AREACODE", // 新增修改收货地址
      setCartNumber: "SET_CARTNUMBER", // 采购单数量
      setShoppingCart: "SET_SHOPPINGCART", // 采购单
    }),
    //检查是否授信账期额度
    checkApplyFor() {
      let shopId = JSON.parse(this.$route.query.shops)[0].shopId;
      let params = {
        url: api.checkApplyFor,
        method: "POST",
        data: {
          attachs: "",
          productIdList: this.productIdList,
          remarks: "",
          shopId,
        },
      };
      this.sendReq(params, (res) => {
        if (res.code == "200") {
          this.chackData = res.data;
          if (res.data.balanceAmount - this.shopsTotal < 0) {
            this.balanceAmount = true;
          }
        }
      });
    },
    // 申请账期额度
    applyForMoney() {
      let shopId = JSON.parse(this.$route.query.shops)[0].shopId;
      let params = {
        url: api.applyForMoney,
        method: "POST",
        data: {
          attachs: "",
          remarks: "",
          shopId,
        },
      };
      this.sendReq(params, (res) => {
        if (res.code == 200) {
          this.paymentDays = false;
          this.confirmApplyForMoney = true;
          this.checkApplyFor();
        } else {
          // 暂时先这样,后期再改
          this.paymentDays = false;
          this.$message({
            type: "warning",
            message: res.message,
          });
        }
      });
    },
    // 获取地址列表
    getAddressList() {
      let self = this;
      let params = {
        url: api.addressList,
        method: "GET",
        payload: {
          page: 1,
          pageSize: 100,
        },
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.addressData = res.data.list;
          if (res.data.list.length === 1) {
            this.selectAddress(res.data.list[0], 0);
          }
        } else {
          self.$message.warning(res.message);
        }
      });
    },
    // 新增地址
    hideAddDialog() {
      let self = this;
      if (this.newAddress.receiveId) {
        this.updateAddressFun();
        return;
      }
      let params = {
        url: api.newAddress,
        method: "POST",
        data: {
          receiveName: self.newAddress.receiveName,
          receivePhone: self.newAddress.receivePhone,
          receiveAdress: self.newAddress.receiveAdress,
          address: self.newAddress.address,
          label: "",
          defult: self.newAddress.defult.toString(),
        },
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.$message({
            message: "地址添加成功",
            type: "success",
          });
          self.page = 1;
          self.addressData = [];
          self.setAreacode([]);
          self.getAddressList();
          self.newAddressDialog = false;
        } else {
          self.$message.error(res.message);
        }
      });
    },
    // 取消新增地址
    closeAdd() {
      this.newAddressDialog = false;
    },
    // 删除地址
    deleteAdd() {
      let self = this;
      let params = {
        url: api.delAddress,
        method: "DELETE",
        data: {
          receiveId: self.delCurrentAdd.receiveId,
        },
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.showDeleteAdd = false;
          self.$message({
            message: "删除成功",
            type: "success",
          });
          self.page = 0;
          self.addressData = [];
          self.getAddressList();
        } else {
          self.$message.error(res.message);
        }
      });
      // self.showDeleteAdd = false
    },
    // 修改地址
    updateAddressFun() {
      let self = this;

      let params = {
        url: api.updateAddress,
        method: "PUT",
        data: {
          receiveId: self.newAddress.receiveId,
          receiveName: self.newAddress.receiveName,
          receivePhone: self.newAddress.receivePhone,
          receiveAdress: self.newAddress.receiveAdress,
          address: self.newAddress.address,
          label: "",
          defult: self.newAddress.defult.toString(),
        },
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.$message({
            message: "地址修改成功",
            type: "success",
          });
          self.page = 1;
          self.addressData = [];
          self.setAreacode([]);
          self.getAddressList();
          self.newAddressDialog = false;
        } else {
          self.$message.error(res.message);
        }
      });
    },
    showDelete(item) {
      this.showDeleteAdd = true;
      this.delCurrentAdd = item;
    },
    selectAddress(item, index) {
      this.curAdd = index;
      this.currentAddressId = item.receiveId;
      // if (this.$route.query.type) {
      //   this.getSetProList()
      // } else {
      //   this.getWorkSettlement()
      // }
    },
    editAddress(item, index) {
      let addressData = item.receiveAdress.split("-");
      let areaData = [];
      areaData.push(TextToCode[addressData[0]].code);
      areaData.push(TextToCode[addressData[0]][addressData[1]].code);
      areaData.push(
        TextToCode[addressData[0]][addressData[1]][addressData[2]].code
      );
      let currentItem = JSON.parse(JSON.stringify(item));
      // console.log(areaData)
      this.seNewAddress(currentItem);
      this.setAreacode(areaData);
      this.newAddressDialog = true;
      this.curDialogAddress = currentItem;
    },
    // 新增地址
    newAddressFn() {
      let obj = {
        receiveName: "",
        receivePhone: "",
        receiveAdress: "",
        address: "",
        label: "",
        defult: "false",
      };
      this.setAreacode([]);
      this.seNewAddress(obj);
      this.newAddressDialog = true;
      this.curDialogAddress = null;
    },
    // 展开更多地址
    openMoreAdd() {
      this.showMoreAddress = !this.showMoreAddress;
    },
    // 拼团商品结算查询
    getWorkSettlement() {
      const rLoading = this.openLoading();
      let self = this;
      self.orderDisTotal = 0;
      self.distributionPrice = 0;
      self.orderTotal = 0;
      let params = {
        url: api.getWorkSettlement,
        method: "POST",
        data: this.workData,
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.settlementData = res.data;
          self.currentAddressId = res.data.receive.receiveId || "";
          self.shopsData = res.data.shops;
          for (let key in self.shopsData) {
            self.orderTotal = self.orderTotal + self.shopsData[key].total;
            self.shopCoupons.push({ id: null, ifAdd: null, reduceMoney: null });
          }
          // for (let i = 0; i < self.shopsData.length; i++){
          //   for (let j = 0; j < self.shopsData[i].products.length; j++){
          //     self.productIdList.push(self.shopsData[i].products[j].productId)
          //   }
          // }
          console.log(self.productIdList)
          self.shopsData.forEach((i) => {
            this.distributionPrice += Number(i.distribution.distributionPrice);
          });
          self.orderDisTotal = Number(self.orderTotal) + this.distributionPrice;
          rLoading.close();
        } else {
          self.$message.warning(res.message);
        }
      });
    },
    // 查询结算产品列表
    getSetProList() {
      const rLoading = this.openLoading();
      let self = this;
      self.orderDisTotal = 0;
      self.distributionPrice = 0;
      self.orderTotal = 0;
      this.$nextTick(() => {
        let params = {
          url: api.getSettlement,
          method: "POST",
          data: {
            type: this.type,
            shops: this.shopData,
            ifWork: this.ifWork,
            receiveId: this.currentAddressId,
          },
        };
        self.sendReq(params, (res) => {
          // Q
          if (res.code === "200") {

            this.shopsTotal = res.data.shops[0].total;
            this.enablePaymentMode = res.data.enablePaymentMode;
            this.chargePersonPhone = res.data.shops[0].chargePersonPhone;
            this.chargePersonName = res.data.shops[0].chargePersonName;
            self.settlementData = res.data;
            self.currentAddressId = res.data.receive.receiveId || "";
            self.shopsData = res.data.shops;
            self.orderTotal = 0;
            for (let key in self.shopsData) {
              self.orderTotal = self.orderTotal + self.shopsData[key].total;
              self.shopCoupons.push({
                id: null,
                ifAdd: null,
                reduceMoney: null,
              });
            }
            for (let i = 0; i < self.shopsData.length; i++) {
              for (let j = 0; j < self.shopsData[i].products.length; j++) {
                self.productIdList.push(self.shopsData[i].products[j].productId)
              }
            }
            console.log(self.productIdList)
            self.shopsData.forEach((i) => {
              this.distributionPrice += Number(
                i.distribution.distributionPrice
              );
            });
            self.orderDisTotal =
              Number(self.orderTotal) + this.distributionPrice;
            rLoading.close();
            // 检查是否有账期
            this.checkApplyFor();
          } else {
            self.$message.warning(res.message);
            self.$router.back();
          }
        });
      });
    },
    // preferentialUse (item, index) {
    //   if (this.currentCoupon === index) {
    //     this.prefAmount = 0
    //     this.couponCurrent = {}
    //     this.currentCoupon = null
    //   } else {
    //     if (this.shopCouponCurrent.ifAdd === 0) {
    //       this.currentDiscount = 0
    //       this.shopCouponCurrent = {}
    //       this.currentShopCoupon = null
    //     }
    //     this.couponCurrent = item
    //     this.prefAmount = item.reduceMoney
    //     this.currentCoupon = index
    //   }
    // },
    // 选择平台券
    preferentialUse(item, index) {
      if (item.reduceMoney >= this.orderTotal) {
        return this.$message.warning("优惠券金额不能大于付款金额");
      }
      let flag = true;
      this.shopCoupons.forEach((i) => {
        if (i.id && i.ifAdd === 0) {
          flag = false;
        }
      });
      if (flag) {
        if (this.curPrefCouponInx === index) {
          this.prefDis = 0;
          this.curPrefCoupon = null;
          this.curPrefCouponInx = null;
        } else {
          this.prefDis = Number(item.reduceMoney);
          this.curPrefCoupon = item;
          this.curPrefCouponInx = index;
        }
      } else {
        this.$message.warning("已选择的店铺券中存在不能叠加的");
      }
    },
    // selectShopCoupon (item, index) {
    //   if (this.currentShopCoupon === index) {
    //     this.currentDiscount = 0
    //     this.shopCouponCurrent = {}
    //     this.currentShopCoupon = null
    //   } else {
    //     if (item.ifAdd === 0) {
    //       this.prefAmount = 0
    //       this.couponCurrent = {}
    //       this.currentCoupon = null
    //     }
    //     this.orderTotal = this.orderTotal + this.shopDiscountAmount
    //     this.shopDiscountAmount = 0
    //     this.shopCouponCurrent = item
    //     if (item.reduceMoney < 10) {
    //       this.currentDiscount = item.reduceMoney * 0.1
    //     } else {
    //       this.currentDiscount = item.reduceMoney * 0.01
    //     }
    //     this.currentShopCoupon = index
    //   }
    // },
    // 选择店铺券
    selectShopCoupon(item, index, shop) {
      if (shop.couponType === 1) {
        if (shop.reduceMoney >= this.orderDisTotal) {
          return this.$message.warning("优惠券金额不能大于付款金额");
        }
      }
      if (
        shop.ifAdd === 1 ||
        (this.curPrefCoupon === null && shop.ifAdd === 0)
      ) {
        if (this.shopCoupons[index].id === shop.id) {
          this.curShopCoupon = null;
          this.shopCoupons[index].id = null;
          this.shopCoupons[index].ifAdd = null;
          this.shopCoupons[index].reduceMoney = null;
        } else {
          if (item.ids) {
            if (shop.couponType === 1) {
              let disMoney = 0;
              shop.ids.map((i) => {
                item.skus.map((j) => {
                  if (i === j.productId) {
                    disMoney += j.total;
                  }
                });
              });
              if (disMoney - shop.reduceMoney > 0) {
                this.shopCoupons[index].reduceMoney = Number(shop.reduceMoney);
              } else {
                this.shopCoupons[index].reduceMoney = Number(disMoney);
              }
              this.shopCoupons[index].id = shop.id;
              this.shopCoupons[index].ifAdd = shop.ifAdd;
              this.shopCoupons[index].reduceMoney = shop.reduceMoney;
              this.curShopCoupo = shop;
            } else {
              let disMoney = 0;
              shop.ids.map((k) => {
                item.skus.map((l) => {
                  if (k === l.productId) {
                    disMoney += l.total;
                  }
                });
              });
              this.shopCoupons[index].id = shop.id;
              this.shopCoupons[index].ifAdd = shop.ifAdd;
              this.shopCoupons[index].reduceMoney = shop.reduceMoney;
              this.curShopCoupon = shop;
              this.shopCoupons[index].reduceMoney = Number(
                disMoney * (1 - shop.reduceMoney * 0.1)
              );
            }
          } else {
            if (shop.couponType === 1) {
              if (item.total - shop.reduceMoney > 0) {
                this.shopCoupons[index].reduceMoney = Number(shop.reduceMoney);
              } else {
                this.shopCoupons[index].reduceMoney = Number(item.total);
              }
              this.shopCoupons[index].id = shop.id;
              this.shopCoupons[index].ifAdd = shop.ifAdd;
              this.shopCoupons[index].reduceMoney = shop.reduceMoney;
              this.curShopCoupon = shop;
            } else {
              this.shopCoupons[index].id = shop.id;
              this.shopCoupons[index].ifAdd = shop.ifAdd;
              this.shopCoupons[index].reduceMoney = shop.reduceMoney;
              this.curShopCoupon = shop;
              this.shopCoupons[index].reduceMoney = Number(
                item.total * (1 - shop.reduceMoney * 0.1)
              );
            }
          }
        }
      } else {
        this.$message.warning("此店铺券不能叠加平台券");
        // this.prefDis = 0
        // this.curPrefCoupon = null
        // this.curPrefCouponInx = null
        // if (this.shopCoupons[index].id === shop.id) {
        //   this.shopCouponDis = 0
        //   this.curShopCoupon = null
        //   this.shopCoupons[index].id = null
        //   this.shopCoupons[index].ifAdd = null
        // } else {
        //   if (item.ids) {
        //     if (shop.couponType === 1) {
        //       let disMoney = 0
        //       shop.ids.map(i => {
        //         item.skus.map(j => {
        //           if (i === j.productId) {
        //             disMoney += j.total
        //           }
        //         })
        //       })
        //       if (disMoney - shop.reduceMoney > 0) {
        //         this.shopCouponDis = Number(shop.reduceMoney)
        //       } else {
        //         this.shopCouponDis = Number(disMoney)
        //       }
        //       this.shopCoupons[index].id = shop.id
        //       this.shopCoupons[index].ifAdd = shop.ifAdd
        //       this.curShopCoupo = shop
        //       // this.shopCouponDis = Number(shop.reduceMoney)
        //     } else {
        //       let disMoney = 0
        //       shop.ids.map(k => {
        //         item.skus.map(l => {
        //           if (k === l.productId) {
        //             disMoney += l.total
        //           }
        //         })
        //       })
        //       this.shopCoupons[index].id = shop.id
        //       this.shopCoupons[index].ifAdd = shop.ifAdd
        //       this.curShopCoupon = shop
        //       this.shopCouponDis = Number(disMoney * (1 - shop.reduceMoney * 0.1))
        //     }
        //   } else {
        //     if (shop.couponType === 1) {
        //       if (item.total - shop.reduceMoney > 0) {
        //         this.shopCouponDis = Number(shop.reduceMoney)
        //       } else {
        //         this.shopCouponDis = Number(item.total)
        //       }
        //       this.shopCoupons[index].id = shop.id
        //       this.shopCoupons[index].ifAdd = shop.ifAdd
        //       this.curShopCoupon = shop
        //       // this.shopCouponDis = Number(shop.reduceMoney)
        //     } else {
        //       this.shopCoupons[index].id = shop.id
        //       this.shopCoupons[index].ifAdd = shop.ifAdd
        //       this.curShopCoupon = shop
        //       this.shopCouponDis = Number(item.total * (1 - shop.reduceMoney * 0.1))
        //     }
        //   }
        // }
      }
    },
    // 选择支付方式
    selectPay(type) {
      this.payType = type;
    },
    // 提交支付
    clickPayOrder() {
      if (this.payType === "") {
        this.$message.warning("请选择支付方式");
      } else if (this.currentAddressId === "") {
        this.$message.warning("请选择您的收货地址");
      } else if (this.payType == 4) {
        if (this.chackData.flag != 3) {
          this.$message({
            message:
              "您暂未获得当前店铺（或商品）的账期授权，点击“立即开通”向商家提交申请或者联系商家开通吧~",
            type: "warning",
          });
        } else {
          let shops = [];
          this.shopsData.forEach((j, i) => {
            let skus = [];
            j.skus.forEach((k, n) => {
              if (k.selected) {
                skus.push({
                  skuId: k.skuId,
                  number: k.number,
                  selected: k.selected,
                });
              }
            });
            if (skus.length) {
              shops.push({
                shopId: j.shopId,
                id: this.shopCoupons[i].id || "",
                distribution: {
                  distributionPrice: j.distribution.distributionPrice,
                  logisticsId: j.distribution.logisticsId,
                },
                skus,
              });
            }
          });
          this.submitData.couponId = this.curPrefCoupon
            ? this.curPrefCoupon.couponId
            : "";
          // this.submitData.id = this.curShopCoupon ? this.curShopCoupon.id : ''
          this.submitData.receiveId = this.currentAddressId;
          this.submitData.price = parseFloat(this.orderDisTotal.toFixed(2));
          // this.submitData.discountPrice = this.prefAmount + this.shopDiscountAmount
          this.submitData.discountPrice = parseFloat(
            (this.prefDis + this.shopCouponDis).toFixed(2)
          );
          this.submitData.remark = this.remarksInfo;
          this.submitData.shops = shops;
          this.submitData.paymentMode = Number(this.payType);
          if (this.activityType === "1" && this.ifWork !== "1") {
            this.submitData.shopGroupWorkId = this.workData.shopGroupWorkId;
            this.submitData.type = 1;
            if (this.workData.collageId) {
              this.submitData.collageId = this.workData.collageId;
              this.submitData.type = 2;
            }
          } else if (this.activityType === "2") {
            this.submitData.shopSeckillId = this.shopData[0].shopSeckillId;
            this.submitData.type = 3;
          } else if (this.activityType === "3") {
            this.submitData.shopDiscountId = this.shopData[0].shopDiscountId;
            this.submitData.type = 4;
          }
          // console.log(this.shopData);
          // console.log(this.submitData);
          let _this = this;
          let dialogPrice = this.submitData.price;
          this.$confirm({
            title: "是否确认付款",
            content: (h) => (
              <div>
                待付款金额:{" "}
                <span style="color:#ff4747;font-size:16px;">
                  ¥{dialogPrice}
                </span>
              </div>
            ),
            onOk() {
              _this.submitData.creditConfirm = 1;
              _this.orderSubmit(_this.submitData, "submitData");
            },
            onCancel() {
              _this.submitData.creditConfirm = 0;
              _this.orderSubmit(_this.submitData, "submitData");
            },
            class: "test",
          });
        }
      } else if (this.payType == 6 || this.payType == 7) {
        let shops = [];
        this.shopsData.forEach((j, i) => {
          let skus = [];
          j.skus.forEach((k, n) => {
            if (k.selected) {
              skus.push({
                skuId: k.skuId,
                number: k.number,
                selected: k.selected,
              });
            }
          });
          if (skus.length) {
            shops.push({
              shopId: j.shopId,
              id: this.shopCoupons[i].id || "",
              distribution: {
                distributionPrice: j.distribution.distributionPrice,
                logisticsId: j.distribution.logisticsId,
              },
              skus,
            });
          }
        });
        this.submitData.couponId = this.curPrefCoupon
          ? this.curPrefCoupon.couponId
          : "";
        // this.submitData.id = this.curShopCoupon ? this.curShopCoupon.id : ''
        this.submitData.receiveId = this.currentAddressId;
        this.submitData.price = parseFloat(this.orderDisTotal.toFixed(2));
        // this.submitData.discountPrice = this.prefAmount + this.shopDiscountAmount
        this.submitData.discountPrice = parseFloat(
          (this.prefDis + this.shopCouponDis).toFixed(2)
        );
        this.submitData.remark = this.remarksInfo;
        this.submitData.shops = shops;
        this.submitData.paymentMode = Number(this.payType);
        if (this.activityType === "1" && this.ifWork !== "1") {
          this.submitData.shopGroupWorkId = this.workData.shopGroupWorkId;
          this.submitData.type = 1;
          if (this.workData.collageId) {
            this.submitData.collageId = this.workData.collageId;
            this.submitData.type = 2;
          }
        } else if (this.activityType === "2") {
          this.submitData.shopSeckillId = this.shopData[0].shopSeckillId;
          this.submitData.type = 3;
        } else if (this.activityType === "3") {
          this.submitData.shopDiscountId = this.shopData[0].shopDiscountId;
          this.submitData.type = 4;
        }
        // console.log(this.shopData);
        // console.log(this.submitData);
        let _this = this;
        let dialogPrice = this.submitData.price;
        this.$confirm({
          title: "是否确认付款",
          content: (h) => (
            <div>
              待付款金额:{" "}
              <span style="color:#ff4747;font-size:16px;">
                ¥{dialogPrice}
              </span>
            </div>
          ),
          onOk() {
            _this.submitFlag = true
            _this.submitData.creditConfirm = 1;
            _this.orderSubmit(_this.submitData, "submitData");
          },
          onCancel() {
            _this.submitFlag = false
            _this.submitData.creditConfirm = 1;
            _this.orderSubmit(_this.submitData, "submitData");
          },
          class: "test",
        });

      }
      else {
        let shops = [];
        this.shopsData.forEach((j, i) => {
          let skus = [];
          j.skus.forEach((k, n) => {
            if (k.selected) {
              skus.push({
                skuId: k.skuId,
                number: k.number,
                selected: k.selected,
              });
            }
          });
          if (skus.length) {
            shops.push({
              shopId: j.shopId,
              id: this.shopCoupons[i].id || "",
              distribution: {
                distributionPrice: j.distribution.distributionPrice,
                logisticsId: j.distribution.logisticsId,
              },
              skus,
            });
          }
        });
        this.submitData.couponId = this.curPrefCoupon
          ? this.curPrefCoupon.couponId
          : "";
        // this.submitData.id = this.curShopCoupon ? this.curShopCoupon.id : ''
        this.submitData.receiveId = this.currentAddressId;
        this.submitData.price = parseFloat(this.orderDisTotal.toFixed(2));
        // this.submitData.discountPrice = this.prefAmount + this.shopDiscountAmount
        this.submitData.discountPrice = parseFloat(
          (this.prefDis + this.shopCouponDis).toFixed(2)
        );
        this.submitData.remark = this.remarksInfo;
        this.submitData.shops = shops;
        this.submitData.paymentMode = Number(this.payType);
        if (this.activityType === "1" && this.ifWork !== "1") {
          this.submitData.shopGroupWorkId = this.workData.shopGroupWorkId;
          this.submitData.type = 1;
          if (this.workData.collageId) {
            this.submitData.collageId = this.workData.collageId;
            this.submitData.type = 2;
          }
        } else if (this.activityType === "2") {
          this.submitData.shopSeckillId = this.shopData[0].shopSeckillId;
          this.submitData.type = 3;
        } else if (this.activityType === "3") {
          this.submitData.shopDiscountId = this.shopData[0].shopDiscountId;
          this.submitData.type = 4;
        }
        // console.log(this.shopData);
        // console.log(this.submitData);
        this.orderSubmit(this.submitData, "submitData");
      }
    },
    // 提交订单
    orderSubmit(subData) {
      let self = this;
      let params = {
        url: api.orderSubmit,
        method: "POST",
        data: subData,
      };
      self.spinning = true;
      self.sendReq(params, (res) => {
        self.spinning = false;
        if (res.code === "200") {
          // self.pay(res.data)
          self.payInfo = res.data;
          self.getTrolleyList();
          // console.log(res.data, '提交返回')

          if (self.payType == 1) {
            self.weChatPay(res);
          } else if (self.payType == 3) {
            self.offlinePay(res);
          } else if (self.payType == 4) {
            this.$message.success("将为您跳转订单详情...");
            setTimeout(() => {
              this.$router.push({
                path: "/orderDetail_B2B",
                query: {
                  parentId: res.data.orderId,
                },
              });
            }, 2000);
          } else if (self.payType == 6 ||self.payType == 7) {
            if (res.data && res.data.url) {
              if (self.submitFlag) {
                self.$message({
                  message: '订单提交成功，即将跳转支付...',
                  type: "success",
                });
                setTimeout(() => {
                  var a = document.createElement('a');
                  a.setAttribute('href', res.data.url);
                  a.setAttribute('target', '_blank');
                  a.setAttribute('id', "toPay");
                  // 防止反复添加
                  if (!document.getElementById("toPay")) document.body.appendChild(a);
                  a.click();
                  // let url = "https://cpay3.dccnet.com.cn/corporpay/servlet/ICBCCPayBusinessServlet?unique_serialno=2022110211261470900000000002820013&signstr=88DCA78EF441521B4E49DEC55DF1E03C74A14D2EE84EFE210CAFA25F913E8B13D5CEBBF7FCE625D2"
                  // window.open("_blank")
                  // window.location.href = res.data.url

                }, 2000);
              } else {
                this.$message.success("将为您跳转订单详情...");
                setTimeout(() => {
                  this.$router.push({
                    path: "/orderDetail_B2B",
                    query: {
                      parentId: res.data.orderId,
                    },
                  });
                }, 2000);
              }

            }
          }
          // self.weChatDialog = true
          // self.chatTimer = setInterval(() => {
          //   self.checkPay(res.data)
          // }, 3000)
        } else if (res.code === "70007") {
          self.$message({
            message:
              "订单金额超额（≥5万元），暂不支持在线支付，您可选择转账汇款或账期支付进行支付。",
            type: "warning",
          });
        } else {
          if (JSON.stringify(res.errorData) === "{}") {
            self.$message({
              message: res.message,
              type: "warning",
            });
          } else {
            self.$message({
              message: res.errorData,
              type: "warning",
            });
          }

        }
      });
    },
    weChatPay(res) {
      let self = this;
      self.weChatDialog = true;
      self.chatTimer = setInterval(() => {
        self.checkPay(res.data);
      }, 2000);
    },
    offlinePay(res) {
      this.$router.push({
        path: "/orderDetail_B2B",
        query: {
          parentId: res.data.orderId,
          showProcess: true,
        },
      });
      // this.$router.push({path: '/myOrder'})
    },
    // 模拟支付
    pay(data) {
      let params = {
        url: api.pay,
        method: "PUT",
        data: {
          money: data.money,
          orderId: data.orderId,
          type: 1,
        },
      };
      this.sendReq(params, (res) => {
        if (res.code === "200") {
          this.$router.push({ path: "/myOrder" });
        }
      });
    },
    // 查询订单是否支付成功
    checkPay(paramsData) {
      setTimeout(() => {
        let self = this;
        let params = {
          url:
            api.checkPay +
            `?collageId=${paramsData.collageId}&money=${paramsData.money}&orderId=${paramsData.orderId}&type=1`,
          method: "GET",
        };
        self.sendReq(params, (res) => {
          if (res.code === "200") {
            if (res.data.code === "SUCCESS") {
              self.$message({
                message: "支付成功！",
                type: "success",
              });
              clearInterval(self.chatTimer);
              self.getTrolleyList();
              self.$router.push({ path: "/myOrder" });
            }
          } else {
            clearInterval(self.chatTimer);

            self.$message({
              message: res.message,
              type: "error",
            });
          }
        });
      }, 0);
    },
    // 获取采购单列表
    async getTrolleyList() {
      const vm = this;
      const params = {
        url: api.getTrolleyList,
        method: "GET",
      };
      vm.sendReq(params, (res) => {
        const d = res.data;
        let cartNumber = 0;
        // console.log(d)
        if (d.length) {
          d.forEach((j) => {
            cartNumber = cartNumber + j.skus.length;
          });
        }
        this.setShoppingCart(d);
        this.setCartNumber(cartNumber);
      });
    },
    // 取消支付
    handleClose() {
      let _this = this;
      this.$confirm({
        okText: "确定",
        cancelText: "取消",
        title: "取消支付",
        content: "确认取消支付？",
        onOk() {
          clearInterval(_this.chatTimer);
          _this.$router.push({ path: "/myOrder" });
        },
        onCancel() { },
      });
      // this.$confirm('确认取消支付？')
      //   .then(_ => {
      //     clearInterval(this.chatTimer)
      //     this.$router.push({path: '/myOrder'})
      //   })
      //   .catch(_ => {})
    },
  },
  // watch: {
  //   prefAmount (val, oldVal) {
  //     if (val === 0) {
  //       this.orderTotal = this.orderTotal + oldVal
  //     } else {
  //       this.orderTotal = this.orderTotal - val
  //     }
  //   },
  //   currentDiscount (val, oldVal) {
  //     if (val === 0) {
  //       this.orderTotal = this.orderTotal + this.shopDiscountAmount
  //       this.shopDiscountAmount = 0
  //     } else {
  //       this.shopDiscountAmount = this.orderTotal - (this.orderTotal * val)
  //       this.orderTotal = this.orderTotal - this.shopDiscountAmount
  //     }
  //   }
  // }
  watch: {
    shopCoupons: {
      handler(newVal, oldVal) {
        this.shopCouponDis = 0;
        this.shopCoupons.forEach((i) => {
          if (i.id) {
            this.shopCouponDis += i.reduceMoney;
          }
        });
        this.orderDisTotal =
          this.orderTotal +
          this.distributionPrice -
          this.shopCouponDis.toFixed(2) -
          this.prefDis;
        if (this.orderDisTotal <= 0) {
          this.orderDisTotal = 0;
        }
      },
      deep: true,
    },
    prefDis(newVal, oldVal) {
      this.shopCouponDis = 0;
      this.shopCoupons.forEach((i) => {
        if (i.id) {
          this.shopCouponDis += i.reduceMoney;
        }
      });
      this.orderDisTotal =
        this.orderTotal +
        this.distributionPrice -
        this.shopCouponDis.toFixed(2) -
        this.prefDis;
      if (this.orderDisTotal <= 0) {
        this.orderDisTotal = 0;
      }
    },
  },
};
</script>
<style lang="scss">
.main {
  background: #f5f5f5;
}
</style>
<style lang="scss" scoped>
.placeOrder {
  margin: 20px auto;
  padding: 27px 48px;
  background: #ffffff;

  .poTitle {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
  }

  .poAddressList {
    display: flex;
    width: 100%;
    border: 1px solid #e5e5e5;
    padding: 20px;
    margin-bottom: 30px;
    box-sizing: border-box;
    justify-content: space-between;

    .poAddListTit {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 177px;
      height: 177px;
      border: 2px dotted #c9c9c9;
      border-radius: 8px;
      margin: 22px;

      i {
        color: #c9c9c9;
        font-size: 46px;
        margin-bottom: 10px;
      }

      span:nth-child(2) {
        color: #76787a;
        font-size: 14px;
        cursor: pointer;
      }
    }

    .poAddListBox {
      width: 70%;
      display: flex;
      justify-content: flex-end;

      &>div:first-child {
        font-size: 16px;
        color: #333333;
        padding: 19px 27px 0 0;
      }

      &>div:last-child {}

      // margin:20px 50px 0 50px;
      .showMoreBox {
        width: 843px;
        height: 203px;
        overflow: hidden;
      }

      .showMoreAdd {
        height: auto;
      }

      .addressItem {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        width: 100%;
        border: 1px solid #e5e5e5;
        margin-bottom: 7px;
        height: 62px;
        cursor: pointer;
        padding-right: 27px;

        span {
          color: #666666;
          font-size: 14px;
        }

        span:nth-child(1) {
          width: 180px;
          height: 31px;
          line-height: 31px;
          // text-align: center;
          // border: 1px solid #CCCCCC;
          // border-radius: 2px;
          padding: 0 0 0 27px;
          margin-right: 15px;
          position: relative;
          // i {
          //   font-size: 16px;
          //   height: 16px;
          //   line-height: 16px;
          //   position: absolute;
          //   right: -1px;
          //   bottom: 0;
          //   color: $mainColor;
          // }
        }

        span:nth-child(2) {
          width: 280px;
          margin-right: 20px;
        }

        .phone {
          margin-right: 20px;
        }

        .defaultAddress {
          width: 100px;
          display: flex;
          align-items: center;
          margin-left: auto;
        }

        .hasHeader:before {
          content: "";
          display: inline-block;
          width: 5px;
          height: 5px;
          background: #f77b0b;
          border-radius: 50%;
          margin-right: 7px;
          margin-left: -7px;
        }

        .el-icon-edit {
          font-size: 18px;
          padding-right: 15px;
        }
      }

      .openMore {
        font-size: 20px;
        color: #cccccc;
        cursor: pointer;
        text-align: center;
      }

      .currentAddress {
        span:nth-child(1) {
          border-color: $mainColor;
        }
      }

      .addressActive {
        position: relative;
        border: 1px solid #f77b0b;

        &>i {
          position: absolute;
          right: -1px !important;
          bottom: -1px;
          color: #f77b0b;
          font-size: 16px;
          height: 16px;
          line-height: 16px;
        }
      }

      .showMoreAdd {
        height: auto;
      }
    }
  }

  >>>.el-dialog {
    .el-dialog__body {
      background: #f8f8f8;
    }

    .el-dialog__header {
      text-align: center;
    }

    .el-dialog__footer {
      text-align: center;

      .dialog-footer {
        text-align: center;

        button {
          height: 45px;
          width: 160px;
        }
      }
    }
  }

  .poAddressBox {
    .noAddress {
      width: 300px;
      height: 166px;
      display: flex;
      align-items: center;
      text-align: center;
      border: 2px solid #dddddd;
      border-radius: 4px;
      margin-top: 40px;
      justify-content: center;
      cursor: pointer;
      margin-bottom: 70px;

      span {
        font-size: 16px;
        color: #666666;
        display: block;
      }

      span:nth-child(1) {
        font-size: 26px;
        margin-bottom: 18px;
      }
    }
  }

  .orderList {
    background: #fcfcfc;
    border: 1px solid #e5e5e5;
    margin-bottom: -1px;

    .orderInfoTit {
      width: 100%;
      display: flex;
      height: 44px;
      line-height: 44px;
      color: #333333;
      font-size: 14px;
      font-weight: 400;
    }

    span {
      text-align: center;
    }

    span:nth-child(1) {
      width: 40%;
      text-align: left;
      padding-left: 125px;
      box-sizing: border-box;
    }

    span:nth-child(2) {
      width: 20%;
      text-align: left;
    }

    span:nth-child(3) {
      width: 15%;
    }

    span:nth-child(4) {
      width: 15%;
    }

    span:nth-child(5) {
      width: 10%;
    }

    span:nth-child(6) {
      width: 10%;
    }
  }

  .couponBox {
    .couponTitle {
      color: #333333;
      font-size: 16px;
      font-weight: bold;
      height: 45px;
      line-height: 45px;
      border-bottom: 1px solid #e5e5e5;

      span {
        color: #333333;
        cursor: pointer;

        i {
          margin-left: 5px;
        }
      }
    }

    .discountList {
      margin-top: 30px;

      .couponItem {
        width: 245px;
        border: 1px solid #eeeeee;
        border-radius: 18px;
        overflow: hidden;
        margin: 0 50px 50px 0;
        float: left;
        cursor: pointer;

        // &:nth-child(4n) {
        //   margin-right: 0;
        // }
        .couponItemTop {
          background: #fd5b5b;
          color: #ffffff;
          padding: 20px;
          box-sizing: border-box;
          position: relative;

          img {
            opacity: 0.2;
            position: absolute;
            top: 40%;
          }

          .couponType {
            position: absolute;
            top: 1px;
            right: -33px;
            width: 100px;
            transform: rotate(45deg);
            background: #ffffff;
            color: #fd5b5b;
            text-align: center;
            height: 40px;
            line-height: 50px;
          }

          span {
            font-size: 12px;
            display: block;
            margin-bottom: 18px;

            i {
              margin-right: 5px;
              font-style: normal;
              font-size: 16px;
            }
          }

          span:nth-child(2) {
            font-size: 18px;
          }

          span:nth-child(4) {
            margin-bottom: 0;
          }
        }

        .couponItemBot {
          height: 40px;
          line-height: 40px;
          background: #f3f3f3;
          color: #333333;
          position: relative;
          text-align: center;
          cursor: pointer;

          .currentSelect {
            color: $mainColor;
            position: absolute;
            right: -1px;
            bottom: 0;
            font-size: 40px;
          }
        }
      }

      .active {
        border: 1px solid $mainColor;
      }
    }

    .couponList {
      margin-top: 10px;

      .payTit {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 20px;
      }

      .dialog-footer {
        display: flex;
        justify-content: flex-end;
      }

      .confimPaymentDays1 {
        width: 111px;
        height: 44px;
        line-height: 44px;
        background: #f5f5f5;
        border-radius: 2px;
        border: 1px solid #e5e5e4;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #999999;
        margin-right: 22px;
        cursor: pointer;
      }

      .confimPaymentDays2 {
        width: 140px;
        height: 44px;
        line-height: 44px;
        background: #f77b0b;
        border-radius: 2px;
        border: 1px solid #f77b0b;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        margin-right: 0;
        cursor: pointer;
      }

      >>>.el-dialog__header {
        text-align: left;
      }

      >>>.el-dialog__body {
        background-color: #fff;
        padding: 30px 48px 26px 48px;
      }

      >>>.el-dialog__footer {
        padding: 0 48px 30px 48px;
      }

      .confimPaymentDaysContent {
        >.p1 {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #606266;
          line-height: 36px;
        }

        >p:last-child {
          margin-top: 17px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 20px;

          >span {
            margin-left: 18px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #f77b0b;
            line-height: 20px;
          }
        }
      }

      .confirmApplyForMoney {
        padding: 20px 0;

        >div {
          text-align: center;

          >img {
            width: 74px;
            height: 74px;
          }
        }

        >div:last-child {
          margin-top: 15px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 28px;
        }
      }
    }
  }

  .payBox {
    // .payTit {
    //   font-size: 20px;
    //   color: #333333;
    //   font-weight: bold;
    // }
  }

  .placeOrderBtn {
    margin-top: 50px;
    width: 100%;
    background: #f7f7f7;
    padding: 30px;
    box-sizing: border-box;
    text-align: right;

    span {
      display: block;
      margin-bottom: 20px;
      font-size: 14px;
      color: #333333;
    }

    span:nth-child(3) {
      font-size: 18px;

      b {
        color: $mainColor;
      }
    }
  }

  // .payList {
  //   display: flex;
  //   margin: 20px 0 0 50px;
  //   span {
  //     color: #666666;
  //     font-size: 16px;
  //     font-weight: 400;
  //     display: flex;
  //     align-items: center;
  //     cursor: pointer;
  //     position: relative;
  //     i {
  //       font-size: 26px;
  //       margin-right: 5px;
  //     }
  //     b {
  //       color: $mainColor;
  //       position: absolute;
  //       right: -1px;
  //       bottom: -1px;
  //       display: none;
  //     }
  //   }
  //   .payActive {
  //     border: 1px solid $mainColor;
  //     b {
  //       display: block;
  //     }
  //   }
  //   span {
  //     border: 1px solid #E5E5E5;
  //     padding: 5px 10px;
  //     margin-right: 15px;
  //   }
  //   span:nth-child(1) {
  //     i:nth-child(1) {
  //       color: #40ba49;
  //       cursor: pointer;
  //     }
  //   }
  //   span:nth-child(2) {
  //     i {
  //       color:  #40ba49;
  //     }
  //   }
  // }
  .payList {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &>div {
      width: 467px;
      height: 120px;
      border-radius: 8px;
      border: 1px solid #d4d4d4;
      display: flex;
      align-items: center;
      // justify-content: space-between;
      cursor: pointer;
      padding: 0 20px;
      position: relative;
      overflow: hidden;
      margin: 0 5px 10px;

      &>img {
        max-width: 66px;
        max-height: 64px;
        margin-right: 20px;
      }

      &>div {
        display: flex;
        flex-direction: column;
        justify-content: center;

        &>p:nth-child(1) {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          margin-bottom: 10px;
        }

        &>p:nth-child(2) {
          font-size: 14px;
          color: #606266;

          span {
            font-size: 14px;
            color: #ff4747;
            font-weight: bold;
          }
        }
      }

      .hint {
        height: 26px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #606266;
        margin-left: 11px;
      }

      .gray {
        color: #606266 !important;
      }

      .open {
        span {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #f77b0b !important;
        }
      }
    }

    .p1 {
      font-size: 14px;
      font-family: MicrosoftYaHei !important;
      color: #f77b0b !important;
      line-height: 19px !important;
    }

    .payActive {
      border-color: #f77b0b;
    }

    .payActive {
      &>span {
        position: absolute;
        width: 83px;
        height: 70px;
        background: #f77b0b;
        color: #ffffff;
        font-size: 30px;
        border-radius: 50%;
        right: -32px;
        top: -37px;
        display: flex;
        align-items: flex-end;
        padding: 0 0 4px 13px;
      }
    }
  }

  .payment {
    width: 80%;
    margin: 0 auto;

    .paymentBox {
      margin-top: 50px;
      display: flex;
      justify-content: center;

      .successBox,
      .errorBox {
        width: 240px;
        text-align: center;
      }

      .successBox {
        border-right: 1px solid #dddddd;

        >>>.el-button {
          border: 1px solid $mainColor;
        }
      }

      span {
        display: block;
        margin-bottom: 20px;
      }
    }

    .paymentInfo {
      text-align: center;
      margin-top: 60px;

      p {
        font-size: 16px;
        color: #999999;
        line-height: 30px;

        b {
          color: #ff7800;
          cursor: pointer;
          font-weight: normal;
        }
      }
    }
  }

  .weChatBox {
    // display: flex;
    // justify-content: center;
    text-align: center;

    img {
      width: 100%;
    }

    .qCode {
      padding: 10px 20px;
      width: 100%;
      text-align: center;

      img {
        width: 60%;
      }
    }

    .weChatInfo {
      width: 50%;
    }
  }

  .weChat {
    >>>.el-dialog__body {
      background: #ffffff;
    }
  }

  .errorDialog {
    text-align: center;

    .errorTit {
      span {
        font-size: 50px;
        color: red;
      }

      p {
        margin: 30px 0;
      }
    }

    span {
      display: block;
    }
  }

  .remarksBox {
    display: flex;
    background: #f7f7f7;
    padding: 25px;
    border-radius: 8px;
    margin-bottom: 30px;

    .remarksInfo {
      width: 100%;

      >>>.el-textarea__inner {
        width: 100%;
        height: 84px;
      }
    }

    .selectBox {
      margin-left: 70px;

      label {
        color: #666666;
        font-size: 16px;
        font-weight: normal;
      }
    }

    .shopTotal {
      color: $mainColor;
      flex: 1;
      text-align: right;
    }
  }
}

.el-dialog__title {
  padding: 0 20px !important;
  line-height: 24px;
  font-size: 18px;
  color: #303133;
}
</style>



// WEBPACK FOOTER //
// src/views/placeOrder/index.vue